<template>
  <section class="chat-history">
    <div class="chat-history--container">
      <div class="d-flex chat-history--container--actions">
        <v-spacer />
        <div class="text-xs-right"></div>
      </div>

      <div class="chat-token botter--widget">
        <div
          class="chat-history--wrapper"
          v-infinite-scroll="scrollToMoreMsgs"
          infinite-scroll-disabled="busy2"
          infinite-scroll-distance="0"
          infinite-scroll-immediate-check="false"
        >
          <!--          <chat-attributes v-if="attributes" :attributes="attributes"/>-->
          <div class="chat-token--content botter-wdiget-body">
            <section v-for="msg in messages" :key="msg._id">
              <message :msg="msg" />
            </section>
          </div>
        </div>
      </div>

      <message-input
        :selected-session="selectedSession"
        @pushMessage="pushMessage"
        @sendBlock="sendBlock"
      />
    </div>
  </section>
</template>

<script>
import infiniteScroll from "vue-infinite-scroll";
import message from "./message";
import messageInput from "./messagesInput/messageInput";
export default {
  name: "singleSessionData",
  components: {
    message,
    messageInput,
  },
  directives: { infiniteScroll },
  props: {
    selectedSession: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  async mounted() {
    await this.getMessages();
    await this.getAttributes();
  },
  data() {
    return {
      messages: [],
      attributes: [],
      page: 1,
      perPage: 200,
      hasNext: false,
    };
  },
  methods: {
    async getMessages(loadMore) {
      this.$store.dispatch("setLoader", true);
      const response = await this.$http_session_manager.get(
        `/messages/session/${this.selectedSession._id}?per_page=${this.perPage}&page=${this.page}`
      );

      if (loadMore) {
        this.messages = this.messages.concat(response.data.messages);
      } else {
        this.messages = response.data.messages;
      }
      this.hasNext = response.data.hasNext;
      this.$store.dispatch("setLoader", false);
    },
    async getAttributes() {
      this.$store.dispatch("setLoader", true);
      const response = await this.$http_session_manager.get(
        `/sessions/attributes/?gateway_session_id=${this.selectedSession.gateway_session_id}&bot_id=${this.$store.state.bot.botId}`
      );
      this.attributes = JSON.parse(response.data);
    },
    scrollToMoreMsgs() {
      if (this.hasNext) {
        this.page++;
        this.getMessages(true);
      }
    },
    pushMessage(message) {
      this.messages.push(message);
      setTimeout(() => {
        let scrollElement = document.querySelector(".chat-history--wrapper");
        if (scrollElement)
          scrollElement.scrollTop = scrollElement.scrollHeight + 50;
      }, 50);
    },
    sendBlock() {
      this.getMessages();
      setTimeout(() => {
        let scrollElement = document.querySelector(".chat-history--wrapper");
        if (scrollElement)
          scrollElement.scrollTop = scrollElement.scrollHeight + 200;
        document.getElementById("resume-chat").click();
      }, 800);
    },
  },
  computed: {
    selectedSessionId() {
      return this.selectedSession._id;
    },
  },
  watch: {
    async selectedSessionId() {
      await this.getMessages();
      //this.getAttributes()
    },
  },
};
</script>

<style scoped></style>
